<template lang="pug">
div
  .bg-login(data-id="login-cover-image")
    .page-container.modal-dialog-centered.mx-auto.my-0(style="max-width: 500px;padding: 0 8px;")
      .login.login-v2.w-100.mx-auto(data-pageload-addclass='animated fadeIn')
        .user-wrap
          i.fas.fa-user
        .login-header
          .brand.text-yellow.text-center.text-uppercase
            b {{ $t("title.first_time_page") }}
        .login-content
          b-form.margin-bottom-0(@submit.stop.prevent="submit" novalidate :disabled="!submission.success")
            .form-group.m-b-20
              DebounceInput(
                required
                type="text"
                ref="username"
                autocomplete="new-password"
                v-model.trim.lazy="$v.username.$model"
                :placeholder='$t("ui.username")'
                :disabled="loading"
                :dirty="$v.username.$dirty"
                :error="$v.username.$error"
                :maxLength="$v.username.$params.maxLength.max"
              )
              ValidateResult(:value="$v.username" :name="$t('ui.username')")
            .form-group.m-b-20
              b-input-group.input-group-sm
                DebounceInput(
                  required
                  :type=" (isPWShown) ? 'password' : 'text'"
                  autocomplete="new-password"
                  v-model.trim.lazy="$v.password.$model"
                  :placeholder='$t("ui.password")'
                  :disabled="loading"
                  :dirty="$v.password.$dirty"
                  :error="$v.password.$error"
                  :maxLength="$v.password.$params.maxLength.max"
                )
                .input-group-append(style="cursor: pointer;")
                  b-button.btn.btn-outline-secondary.btn-sm(:pressed.sync="isPWShown" style="border-top-right-radius: 0;border-bottom-right-radius: 0;")
                    i.fa(:class=" (isPWShown) ? 'icon-eye-open fa-eye' : 'icon-eye-close fa-eye-slash'")
                  PasswordRules
                ValidateResult(:value="$v.password" :name="$t('ui.password')" :errors="passwordErrors")
              .pwstrength-progress.mt-2(v-if="password")
                .progress(style="position: relative")
                  .progress-bar(
                    role="progressbar"
                    :style="{ width: passwordStrength.score + '%', backgroundColor: passwordStrength.barColor }"
                    :aria-valuenow="passwordStrength.score"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  )
                  span.progress-text(:style="{ color: passwordStrength.textColor || '#fff' }") {{ passwordStrength.strength }} ({{ passwordStrength.score }}/100)
            .form-group.m-b-20
              b-input-group.input-group-sm
                DebounceInput(
                  required
                  :type=" (isCPWShown) ? 'password' : 'text'"
                  autocomplete="new-password"
                  v-model.trim.lazy="$v.confirm_password.$model"
                  :placeholder='$t("ui.confirm_password")'
                  :disabled="loading"
                  :dirty="$v.confirm_password.$dirty"
                  :error="$v.confirm_password.$error"
                )
                .input-group-append(style="cursor: pointer;")
                  b-button.btn.btn-outline-secondary.btn-sm(:pressed.sync="isCPWShown" style="border-top-right-radius: 6px;border-bottom-right-radius: 6px;")
                    i.fa(:class=" (isCPWShown) ? 'icon-eye-open fa-eye' : 'icon-eye-close fa-eye-slash'")
                ValidateResult(:value="$v.confirm_password" :name="$t('ui.confirm_password')" :name2="$t('ui.password')")
            //- .form-group.m-b-20
            //-   DebounceInput(
            //-     required
            //-     type="text"
            //-     autocomplete="new-password"
            //-     v-model.trim.lazy="$v.security_tag.$model"
            //-     :placeholder='$t("ui.security_tag")'
            //-     :disabled="loading"
            //-     :dirty="$v.security_tag.$dirty"
            //-     :error="$v.security_tag.$error"
            //-     :maxLength="$v.security_tag.$params.maxLength.max"
            //-   )
            //-   ValidateResult(:value="$v.security_tag" :name="$t('ui.security_tag')")
            .form-group.m-b-20
              b-input-group.input-group-sm
                DebounceInput(
                  required
                  type="text"
                  ref="security_code"
                  autocomplete="new-password"
                  v-model.trim.lazy="$v.security_code.$model"
                  :placeholder='$t("ui.security_code")'
                  :disabled="loading"
                  :dirty="$v.security_code.$dirty"
                  :error="$v.security_code.$error"
                  :maxLength="$v.security_code.$params.maxLength.max"
                )
                .input-group-append(style="cursor: pointer;")
                  SecurityCodeRules
              ValidateResult(:value="$v.security_code" :name="$t('ui.security_code')" :errors="securityCodeErrors")
            .form-group.m-b-20
              DebounceInput(
                required
                type="text"
                autocomplete="new-password"
                v-model.trim.lazy="$v.confirm_security_code.$model"
                :placeholder='$t("ui.confirm_security_code")'
                :disabled="loading"
                :dirty="$v.confirm_security_code.$dirty"
                :error="$v.confirm_security_code.$error"
                )
              ValidateResult(:value="$v.confirm_security_code" :name="$t('ui.confirm_security_code')" :name2="$t('ui.security_code')")
            .form-group.m-b-20
              b-alert.text-center.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }} 
            .login-buttons
              SubmitButton.btn.btn-block.btn-lg(icon="fa fa-save" :text="$t('ui.save')" variant="primary" :loading="loading" isModal=false)
</template>

<script>
import config from "@/config";
import { required, minLength, maxLength, alphaNum, sameAs, helpers } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import PasswordRules from "@/library/PasswordRules";
import SecurityCodeRules from "@/library/SecurityCodeRules";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    PasswordRules,
    SecurityCodeRules
  },
  data: function() {
    return {
      isPWShown: true,
      isCPWShown: true,
      username: "",
      password: "",
      confirm_password: "",
      passwordErrors: [],
      passwordStrength: { score: 0, strength: "", badgeClass: "", barColor: "#6c757d", textColor: "#fff" },
      securityCodeErrors: [],
      security_tag: "MS",
      security_code: "",
      confirm_security_code: "",
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      redirect: "/login"
    };
  },
  computed: {},
  watch: {
    password(value) {
      if (!value) {
        this.passwordErrors = [];
        this.passwordStrength = { score: 0, strength: "", badgeClass: "", barColor: "#6c757d", textColor: "#fff" };
        return;
      }
      const result = this.$helpers.validatePassword(value);
      this.passwordErrors = result.errors;
      const strengthStyles = {
        Weak: { badgeClass: "text-danger", barColor: "#dc3545", textColor: "#000" },
        Fair: { badgeClass: "text-warning", barColor: "#ffc107", textColor: "#212529" },
        Strong: { badgeClass: "text-primary", barColor: "#007bff", textColor: "#fff" },
        "Very Strong": { badgeClass: "text-success", barColor: "#28a745", textColor: "#fff" }
      };
      const style = strengthStyles[result.strength] || { badgeClass: "text-muted", barColor: "#6c757d", textColor: "#fff" };
      this.passwordStrength = {
        score: result.score,
        strength: result.strength,
        badgeClass: style.badgeClass,
        barColor: style.barColor,
        textColor: style.textColor
      };
    },
    security_code(value) {
      if (!value) {
        this.securityCodeErrors = [];
        return;
      }
      const result = this.$helpers.validateSecurityCode(value);
      this.securityCodeErrors = result.errors;
    }
  },
  mounted () {
    this.$refs.username.$el.focus();
  },
  validations: {
    username: {
      required,
      alphaNum,
      minLength: minLength(6),
      maxLength: maxLength(15)
    },
    password: {
      required,
      valid: function(value) {
        if (!helpers.req(value)) return true;
        return this.$helpers.validatePassword(value).isValid;
      },
      // minLength: minLength(8),
      maxLength: maxLength(50)
    },
    confirm_password: {
      required,
      sameAs: sameAs("password")
    },
    // security_tag: {
    //   required,
    //   minLength: minLength(6),
    //   maxLength: maxLength(20)
    // },
    security_code: {
      required, 
      valid: function(value) {
        if (!helpers.req(value)) return true;
        return this.$helpers.validateSecurityCode(value).isValid;
      },
      minLength: minLength(6),
      maxLength: maxLength(6)
    },
    confirm_security_code: {
      required,
      sameAs: sameAs("security_code")
    }
  },
  methods: {
    reset: function() {
      this.$v.$reset();
      this.submission.success = true;
      this.submission.status = "";
      this.passwordStrength = { score: 0, strength: "", badgeClass: "", barColor: "#6c757d", textColor: "#fff" };
      this.passwordErrors = [];
    },
    submit: function() {
      this.reset();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let new_login_id = this.username.toLowerCase();
        let new_password = this.password;
        let security_tag = this.security_tag
        let security_code = this.security_code
        this.loading = true;

        this.$store
          .dispatch("user/firstTime", { new_login_id, new_password, security_tag, security_code })
          .then(response => {
            this.loading = false;
            this.submission.success = response.success;
            this.submission.status = this.$t("message." + response.errorTag);
            if (this.submission.success == true) {
              this.$swal({
                title: this.$t("ui.success"),
                text: this.$t("message.create_secondary_account_success"),
                type: "success"
              }).then(isConfirm => {
                if (isConfirm) {
                  this.$router.push(this.redirect);
                }
              });
            }
          })
          .catch(response => {
            this.loading = false;
            this.submission.success = response.success;
            this.submission.status = this.$t("message." + response.errorTag); 
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.progress-text {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
  font-size: 0.75rem;
  font-weight: 600;
  pointer-events: none;
}
</style>